import type { Pathname } from 'history';

export function getPathnameFromPathSegments(pathSegments: string[]): Pathname {
  return `/${pathSegments.join('/')}`;
}
